__turbopack_context__.v({
  "Active": "sidebar-navigation-item-with-icon-module__xIIkCq__Active",
  "Anchor": "sidebar-navigation-item-with-icon-module__xIIkCq__Anchor",
  "ItemText": "sidebar-navigation-item-with-icon-module__xIIkCq__ItemText",
});
